import { render, staticRenderFns } from "./DeleteActions.vue?vue&type=template&id=0d03e230"
import script from "./DeleteActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteActions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports